import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-text-dark text-gray-300">
      <div className="max-w-content mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img 
                src="/brandscapes_ai_logo_small_light.png" 
                alt="BrandScapes AI" 
                className="h-12 w-auto max-w-full object-contain sm:h-14"
              />
            </div>
            <p className="text-body font-body text-gray-400 mb-4 max-w-sm">
              Transform your designs into professional mockups instantly with AI. 
              No design skills needed.
            </p>
            <div className="flex space-x-4">
              <button className="w-10 h-10 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center">
                <span className="text-lg">𝕏</span>
              </button>
              <button className="w-10 h-10 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center">
                <span className="text-lg">in</span>
              </button>
              <button className="w-10 h-10 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center">
                <span className="text-lg">▶</span>
              </button>
            </div>
          </div>
          
          {/* Product */}
          <div>
            <h3 className="text-white font-body font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/templates" className="text-label font-body hover:text-white transition-colors">
                  Templates
                </Link>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Features
                </button>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Pricing
                </button>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Updates
                </button>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h3 className="text-white font-body font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  About
                </button>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Blog
                </button>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Contact
                </button>
              </li>
              <li>
                <button className="text-label font-body hover:text-white transition-colors">
                  Support
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-label font-body text-gray-400 mb-4 md:mb-0">
            © 2024 BrandScapes AI. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 text-label font-body">
            <button className="hover:text-white transition-colors">
              Privacy Policy
            </button>
            <button className="hover:text-white transition-colors">
              Terms of Service
            </button>
            <button className="hover:text-white transition-colors">
              Cookie Policy
            </button>
          </div>
        </div>
        
        {/* Made with love */}
        <div className="mt-8 text-center">
          <p className="text-label font-body text-gray-500 flex items-center justify-center gap-1">
            Made with <Heart className="w-4 h-4 text-red-500 fill-current" /> by BrandScapes AI Team
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;